// App.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout';
import LanguageHandler from './components/LanguageHandler';

// ייבוא כל הרכיבים
import Home from './pages/home';
import About from './pages/about';
import Categories from './pages/categories';
import Post from './pages/post';
import Contact from './pages/contact';
import NotFound from './pages/404';
import CreatePostPage from './pages/admin/CreatePostPage';
import CategoryPage from './pages/CategoryPage';
import Login from './pages/Login';
import UserRegister from './pages/UserRegister';
import AdminComments from "./components/admin/commentManger";
import RequireAdmin from './requireAdmin';

import { PostProvider } from './context/PostContext';
import { AuthProvider } from './context/AuthContext';

function App() {
    return (
        <AuthProvider>
            <PostProvider>
                <Layout>
                    <Routes>
                        {/* --- כל הניתובים הרגילים, שאינם תלויי שפה, נמצאים כאן למעלה --- */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<UserRegister />} />

                        {/* --- ניתובים מאובטחים לאדמין --- */}
                        {/* הם לא צריכים קידומת שפה כי הם חלק ממערכת הניהול */}
                        <Route path="/create-post" element={<RequireAdmin><CreatePostPage /></RequireAdmin>} />
                        <Route path="/admin/comments" element={<RequireAdmin><AdminComments /></RequireAdmin>} />
                        {/* ... אפשר להוסיף כאן עוד דפי אדמין בעתיד ... */}

                        {/* --- כאן מתחיל הניתוב הדו-לשוני עבור הגולשים --- */}
                        <Route path="/:lang" element={<LanguageHandler />}>
                            <Route index element={<Home />} />
                            <Route path="about" element={<About />} />
                            <Route path="categories" element={<Categories />} />
                            <Route path="contact" element={<Contact />} />
                            <Route path="category" element={<CategoryPage />} />
                            <Route path="post/:id" element={<Post />} />
                        </Route>

                        {/* --- הפניות אוטומטיות (Redirects) --- */}
                        {/* אם מישהו מגיע לכתובת הראשית, הפנה אותו לגרסה בעברית */}
                        <Route path="/" element={<Navigate to="/he" replace />} />

                        {/* אם מישהו מגיע בטעות לקישור ישן, הפנה אותו לגרסה העברית */}
                        <Route path="/about" element={<Navigate to="/he/about" replace />} />
                        <Route path="/categories" element={<Navigate to="/he/categories" replace />} />
                        <Route path="/contact" element={<Navigate to="/he/contact" replace />} />
                        <Route path="/post/:id" element={<Post />} />


                        {/* עמוד 404 תמיד בסוף */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Layout>
            </PostProvider>
        </AuthProvider>
    );
}

export default App;